"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "primaluna": {
    "2c1ba654": [{
      "hkey": "7fb1282f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "barcone": [{
      "hkey": "7fb1282f",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "primaluna"
    }],
    "9b3a95f0": [{
      "hkey": "e9ee7c3e",
      "slug": "primaluna",
      "name": "Primaluna",
      "primary": true,
      "skipSearch": false
    }],
    "pessina": [{
      "hkey": "e9ee7c3e",
      "slug": "primaluna",
      "name": "Primaluna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "46f5c0d6": [{
      "hkey": "e9ee7c3e",
      "slug": "primaluna",
      "name": "Primaluna",
      "primary": true,
      "skipSearch": false
    }],
    "vimogno": [{
      "hkey": "e9ee7c3e",
      "slug": "primaluna",
      "name": "Primaluna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;